import { gql } from '@apollo/client';

export const SITE_THEME_QUERY = gql`
  query SiteTheme {
    site {
      currentSiteTheme {
        logoUrl
        favicon
      }
    }
  }
`;

export const COMMUNITIES_QUERY = gql`
  query Communities {
    site {
      communities {
        edges {
          node {
            id
            published
            name
          }
        }
      }
    }
  }
`;
